import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { EstimateRangeFieldTypes } from '@openx/types/package';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { RangeFieldGroup } from '../components/RangeFieldGroup';

export const PackageEstimatedRangesSection = () => {
  const { t } = useTranslation();

  const RANGE_FIELDS = useMemo(
    () => [
      {
        from: EstimateRangeFieldTypes.CPM_LOW,
        to: EstimateRangeFieldTypes.CPM_HIGH,
        prefix: '$',
        labelFrom: t('CPM From'),
        labelTo: t('CPM To'),
        dataTest: 'range-cpm',
      },
      {
        from: EstimateRangeFieldTypes.REACH_LOW,
        to: EstimateRangeFieldTypes.REACH_HIGH,
        suffix: 'M',
        labelFrom: t('Unique Reach From'),
        labelTo: t('Unique Reach To'),
        dataTest: 'range-reach',
      },
      {
        from: EstimateRangeFieldTypes.MARKET_REQUESTS_LOW,
        to: EstimateRangeFieldTypes.MARKET_REQUESTS_HIGH,
        suffix: 'M',
        labelFrom: t('Market Requests Volume (Monthly) From'),
        labelTo: t('Market Requests Volume (Monthly) To'),
        dataTest: 'range-market-requests',
      },
    ],
    [t]
  );

  return (
    <Box sx={{ mt: 4 }}>
      <Typography
        variant="h2"
        data-test="package-range-title"
        gutterBottom
        sx={{
          mb: 2,
        }}
      >
        {t('Ranges')}
      </Typography>
      <Grid container spacing={2}>
        {RANGE_FIELDS.map(props => (
          <RangeFieldGroup key={`${props.from}-${props.to}`} {...props} />
        ))}
      </Grid>
    </Box>
  );
};
